const Chat = ({ height = "10px", style }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49792 9.59229H13.6726"
      stroke="#9E8C2F"
      strokeWidth="1.69362"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.17476 16.5874H9.70314L13.6285 19.1984C14.2107 19.5865 14.9957 19.1719 14.9957 18.4663V16.5874C17.642 16.5874 19.4062 14.8232 19.4062 12.1769V6.88435C19.4062 4.23807 17.642 2.47388 14.9957 2.47388H6.17476C3.52847 2.47388 1.76428 4.23807 1.76428 6.88435V12.1769C1.76428 14.8232 3.52847 16.5874 6.17476 16.5874Z"
      stroke="#9E8C2F"
      strokeWidth="1.69362"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Chat;
